import React, { useState, useRef } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Toast } from 'primereact/toast';

const ContactCandidate = () => {
    const [selectedTemplate, setSelectedTemplate] = useState('t-1');
    const [selectedWYSIWYGTemplate, setSelectedWYSIWYGTemplate] = useState(null);
    const [templateName, setTemplateName] = useState('');
    const [emailTemplates, setEmailTemplates] = useState([
        { label: 'Invitation', value: 't-1' },
        { label: "Demande d'informations supplémentaires", value: 't-2' },
        { label: "Demande d'horaire pour entretien", value: 't-3' },
    ]);

    const [emailSubjectContent, setEmailSubject] = useState(`Subject: Interview Invitation for {{job_title}} at {{company_name}}`);

    const [emailContent, setEmailContent] = useState(`
    Dear {{candidate_name}},

    We are pleased to inform you that your application for the position of {{job_title}} at {{company_name}} has been shortlisted. We would like to invite you for an interview to further discuss your qualifications and experience.

    Here are the details of your interview:

    - **Date**: {{interview_date}}
    - **Time**: {{interview_time}}
    - **Location**: {{interview_location}}
    - **Mode**: {{interview_mode}}

    Please confirm your availability by replying to this email or contacting us at {{company_email}}. If you have any questions or need to reschedule, feel free to reach out to us.

    We look forward to meeting you and discussing this exciting opportunity.

    Best regards,

    {{recruiter_name}}
    Recruiter, {{company_name}}
    {{company_address}}
    {{company_phone}}
    {{company_website}}`);

    const [wysiwygContent, setWysiwygContent] = useState('');

    const toast = useRef(null);

    const handleTemplateChange = (e) => {
        setSelectedTemplate(e.value);
        // TODO: Load the selected template content here
    };

    const handleWYSIWYGTemplateChange = (e) => {
        setSelectedWYSIWYGTemplate(e.value);
        // TODO: Load the selected WYSIWYG template content here
        // Important, choose a WYSIWYG library that supports email sending or find 
        // a way to remove certain inline styling/replace with native styles.
    };

    const saveTemplate = () => {
        // TODO: Implement save template
        toast.current.show({ severity: 'success', summary: 'Template Sauvegardé', detail: 'Le template a été sauvegardé avec succès!' });
    };

    const deleteTemplate = () => {
        // TODO: Implement delete template
        toast.current.show({ severity: 'success', summary: 'Template supprimé', detail: 'Le template a été sauvegardé avec succès!' });
    };

    const templatePreview = () => {

        return (<>
            <div className="field">

                <label className="label">Apercu du sujet du mail</label>

                <div className="columns">

                    <div className="column is-10">
                        <InputTextarea
                            value={emailSubjectContent}
                            defaultValue={emailSubjectContent}
                            // onChange={}
                            rows={2}
                            cols={50}
                            className='p-2'
                            style={{ width: '100%', resize: 'none' }} />
                    </div>

                    <div className="column is-narrow">
                        <Dropdown
                            value={selectedTemplate}
                            options={emailTemplates}
                            onChange={handleTemplateChange}
                            placeholder="Select a Template"
                            style={{ height: '100%', alignItems: 'center' }}
                        />
                    </div>

                </div>
            </div>

            <div className="field">
                <label className="label">Apercu du template</label>

                <div className="columns">

                    <div className="column is-10">
                        <InputTextarea
                            value={emailContent}
                            onChange={(e) => setEmailContent(e.target.value)}
                            rows={15}
                            cols={50}
                            className='p-2'
                            style={{ width: '100%', resize: 'none' }}
                            readOnly
                        />
                    </div>

                </div>
            </div>
        </>)
    }

    const templateCreator = () => {

        return (<div className='mb-6'>

            <div className="field">
                <label className="label">Sujet du mail:</label>

                <div className="columns">

                    <div className="column is-10">
                        <InputTextarea
                            value={emailSubjectContent}
                            defaultValue={emailSubjectContent}
                            // onChange={}
                            rows={2}
                            cols={50}
                            className='p-2'
                            style={{ width: '100%', resize: 'none' }} />
                    </div>

                    <div className="column is-narrow">
                        <Dropdown
                            value={selectedWYSIWYGTemplate}
                            options={emailTemplates}
                            onChange={handleWYSIWYGTemplateChange}
                            placeholder="Select a Template"
                            style={{ alignItems: 'center' }}
                        />

                        <div className="buttons mt-3">
                            <button className="button is-info is-light is-outlined is-medium" onClick={saveTemplate}>Sauvegarder</button>
                            <button className="button is-danger is-light is-medium" onClick={deleteTemplate}><i className="fas fa-trash"></i></button>
                        </div>

                    </div>
                </div>

            </div>

            <div className="field">

                <label className="label">Créateur de template d'email (WYSIWYG)</label>

                <div className="columns">
                    <div className="column is-10">
                        <InputTextarea
                            value={wysiwygContent}
                            onChange={(e) => setWysiwygContent(e.target.value)}
                            rows={15}
                            cols={50}
                            className='p-2'
                            style={{ width: '100%', resize: 'none' }} />
                    </div>

                </div>

            </div>
        </div>)
    }

    return (
        <div>
            <Toast ref={toast} position='bottom-right' />

            {templatePreview()}

            <hr className='column is-10 p-0' style={{ backgroundColor: 'rgba(193, 193, 193, 0.5)' }} />

            {templateCreator()}

        </div>
    );
};

export default ContactCandidate;